/*
src/storage/SimpleStoredObject.js
wgbh-skydiagram-testing
astro.unl.edu
2019-07-14
*/


export class SimpleStoredObject {

	static upgradeDatabase(db) {
		db.createObjectStore(this.getStoreName(), {autoIncrement: true});
	}

	static getStoreName() {
		throw new Error('This method must be overridden.');
	}

	constructor() {
		this._db = null;
	}

	_initWithDatabase(db) {
		this._db = db;
		this._storeName = this.constructor.getStoreName();
		let t = this._db.transaction(this._storeName, 'readonly');
		t.onabort = (e) => {
			console.error('The database transaction was aborted.');
		};
		let r = t.objectStore(this._storeName).get(0);
		r.onsuccess = (e) => {
			this._finishInitWithDatabase(e.target.result);
		};
		r.onerror = (e) => {
			console.error('Failed to load stored object from database. Error: '+e.target.errorCode);
		};
	}

	_finishInitWithDatabase(dbObj) {
		// The dbObj argument is the previous stored object in the database -- it may be undefined.
		throw new Error('This method must be overridden.');
	}

	_store(dbObj) {
		if (this._db === null) {
			return;
		}
		let t = this._db.transaction(this._storeName, 'readwrite');
		t.onabort = (e) => {
			console.error('The database transaction was aborted. Local storage space may not be available.');
		};
		let r = t.objectStore(this._storeName).put(dbObj, 0);
		r.onerror = (e) => {
			console.error('Failed to store object in database. Error: '+e.target.errorCode);
		};	
	}

}


